












































import MouvementCard from "./MouvementCard.vue";

export default {
    name: "HistoriqueGroupe",
    components: { MouvementCard },
    props: {
        groupe: Object,
    },
    computed: {
        equipement(): any {
            return this.groupe ? this.groupe.equipement : null;
        },
        libelle(): string {
            if (this.equipement && this.equipement.libelle) {
                return this.equipement.libelle;
            }
            let premier = this.groupe.mouvements[0];
            return premier
                ? premier.equipement_libelle
                : "(équipement supprimé)";
        },
        categorie(): string {
            if (this.equipement && this.equipement.categorie_nom) {
                return this.equipement.categorie_nom;
            }
            let premier = this.groupe.mouvements[0];
            return premier ? premier.equipement_categorie : "";
        },
        isSorti(): boolean {
            return !!this.equipement && this.equipement.statut === "sorti";
        },
    },
};
